import { render } from "./ProjectEmail.vue?vue&type=template&id=6c6dafad&scoped=true&ts=true"
import script from "./ProjectEmail.vue?vue&type=script&lang=ts"
export * from "./ProjectEmail.vue?vue&type=script&lang=ts"

import "./ProjectEmail.vue?vue&type=style&index=0&id=6c6dafad&scoped=true&lang=scss"

import exportComponent from "/home/vsts/work/1/s/src/CRM/OutlookAddin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c6dafad"]])

export default __exports__